import { useEffect, useState } from "react";

// ui
import { Box, Typography, Button } from "@mui/material";

import { PasswordEditModal } from "../component/profile/PasswordEditModal";

// Bar
import TableTopBar from "../component/TableTopBar";
import AiChatSideBar from "../component/AiChatSideBar";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import { getProfile, ProfileResponse } from "../api/profile";

// OtherFunc
import { handleUpdatePassword } from "../lib/auth";
import { useWindowSize } from "../lib/useWindowSize";

// プロフィール項目
const profileColumns = [
  {
    key: "mail_address",
    name: "メールアドレス",
    admin: [
      "マスターアカウント",
      "スタッフアカウント",
      "パートナー",
      "営業アカウント",
    ],
  },
  {
    key: "account_name",
    name: "氏名",
    admin: [
      "マスターアカウント",
      "スタッフアカウント",
      "パートナー",
      "営業アカウント",
    ],
  },
  {
    key: "authority",
    name: "権限",
    admin: [
      "マスターアカウント",
      "スタッフアカウント",
      "パートナー",
      "営業アカウント",
    ],
  },
  {
    key: "phone_number",
    name: "電話番号",
    admin: [
      "マスターアカウント",
      "スタッフアカウント",
      "パートナー",
      "営業アカウント",
    ],
  },
  {
    key: "outside_entry_site_key",
    name: "外部ドメインキー",
    admin: ["パートナー", "営業アカウント"],
  },
];

function Profile() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const { windowWidth, windowHeight } = useWindowSize();

  // プロフィール
  const [profileData, setProfileData] = useState<ProfileResponse>();
  async function getProfileData() {
    setIsLoading(true);
    const detail_data = await getProfile();
    setProfileData(detail_data);
    setIsLoading(false);
  }
  useEffect(() => {
    getProfileData();
  }, []);

  const [aiChatOpen, setAiChatOpen] = useState(false);

  const [editPassword, setEditPassword] = useState<{
    status: "before" | "editing" | "success" | "failed" | string;
    oldPassword: string;
    newPassword1: string;
    newPassword2: string;
  } | null>(null);

  async function putEditData() {
    if (editPassword) {
      setIsLoading(true);
      setEditPassword({
        ...editPassword,
        status: "editing",
      });
      const res = await handleUpdatePassword({
        oldPassword: editPassword?.oldPassword,
        newPassword: editPassword?.newPassword1,
      });
      setEditPassword({
        ...editPassword,
        status: res,
      });
      setIsLoading(false);
    }
  }

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : aiChatOpen
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={false}
        serchOpen={false}
        setSerchOpen={() => {}}
        addDataNames={[]}
        addDataName={""}
        setAddDataName={() => {}}
        addCSVDataNames={[]}
        addCSVDataName={""}
        setAddCSVDataName={() => {}}
        getXLSXDataNames={[]}
        getXLSXDataName={""}
        setGetXLSXDataName={() => {}}
        editDatasNames={[]}
        editDatasName={""}
        setEditDatasName={() => {}}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={setAiChatOpen}
      />
      {!(aiChatOpen && isSmartPhone) && (
        <>
          <Box
            style={{
              marginTop: isSmartPhone ? "90px" : "10px",
              marginLeft: windowWidth < 800 ? "10px" : "calc(50% - 380px)",
              width: windowWidth < 800 ? "calc(100% - 20px)" : "760px",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              position={"static"}
              style={{
                width: "100%",
              }}
            >
              <Box
                className="shippori-antique-regular"
                sx={{
                  display: "inline",
                  fontSize: "16px",
                }}
              >
                プロフィール
              </Box>
            </Typography>
            {profileColumns.map((column, i) => {
              const authority = loginUser ? loginUser?.authority : "";
              if (column.admin.includes(authority)) {
                return (
                  <Box key={"profileBox_" + i}>
                    <Box
                      className="serch-label"
                      sx={{
                        width: "100%",
                        marginTop: "50px",
                        marginLeft: "10px",
                      }}
                    >
                      {column.name}
                    </Box>
                    <Box
                      className="serch-label"
                      sx={{
                        width: "100%",
                        marginLeft: "10px",
                        textAlign: "right",
                        marginTop: "5px",
                        minHeight: "25px",
                        borderBottom: "0.2px solid silver",
                      }}
                    >
                      {profileData?.[column.key]}
                    </Box>
                  </Box>
                );
              }
            })}
          </Box>

          <Box>
            <Button
              style={{
                marginTop: "80px",
                marginBottom: "-25px",
                height: "40px",
                marginLeft: windowWidth < 400 ? "20px" : "calc(50% - 180px)",
                width: windowWidth < 400 ? "calc(100% - 20px)" : "360px",
                textTransform: "none",
              }}
              variant="contained"
              onClick={() =>
                setEditPassword({
                  status: "before",
                  oldPassword: "",
                  newPassword1: "",
                  newPassword2: "",
                })
              }
            >
              <Box className="m-plus-rounded-1c-regular">パスワード変更</Box>
            </Button>
          </Box>
          <PasswordEditModal
            onModal={editPassword !== null && editPassword.status !== "editing"}
            swCloseModal={() => setEditPassword(null)}
            editPassword={editPassword}
            setEditPassword={setEditPassword}
            putEditData={putEditData}
          />
        </>
      )}
      {aiChatOpen && (
        <AiChatSideBar open={aiChatOpen} setOpen={setAiChatOpen} pageName="Profile" />
      )}
    </Box>
  );
}

export default Profile;
